import React, { FC, memo } from 'react';
import { View } from 'react-native';

import { styles } from './styles';

type PageIndicatorProps = {
  focusIndex: number;
  numberOfPages: number;
};

export const PageIndicator: FC<PageIndicatorProps> = memo(({ focusIndex, numberOfPages }) => {
  const indicators = [];

  for (let index = 0; index < numberOfPages; index++) {
    indicators.push(
      <View
        key={`alert_index_indicator_${index}`}
        style={[
          styles.indicatorDot,
          index === 0 ? styles.firstDot : null,
          index === focusIndex ? styles.focusedDot : null,
        ]}
      />,
    );
  }
  return <View style={styles.pageIndicator}>{indicators}</View>;
});
